import { render, staticRenderFns } from "./AboutText.vue?vue&type=template&id=cb8dba52&scoped=true&"
import script from "./AboutText.vue?vue&type=script&lang=js&"
export * from "./AboutText.vue?vue&type=script&lang=js&"
import style0 from "./AboutText.vue?vue&type=style&index=0&id=cb8dba52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8dba52",
  null
  
)

export default component.exports